import { CheckCircleIcon, XMarkIcon } from "@heroicons/react/24/outline";

import type { StatusType } from "@/types/types";
import { classNames } from "@/utils/classNames";

export function StatusMessage({ status }: { status: StatusType }) {
  if (status === null) {
    return null;
  }

  return (
    <div
      className={classNames(
        "flex items-start space-x-2 rounded-lg p-4",
        status.type === "success" ? "bg-green-50" : "bg-red-50"
      )}
    >
      <div
        className={classNames(
          "flex-shrink-0",
          status.type === "success" ? "text-green-600" : "text-red-600"
        )}
      >
        {status.type === "success" ?
          <CheckCircleIcon className="h-5 w-5" />
        : <XMarkIcon className="h-5 w-5" />}
      </div>
      <div
        className={classNames(
          "ml-3 text-sm",
          status.type === "success" ? "text-green-800" : "text-red-800"
        )}
      >
        {status.message}
      </div>
    </div>
  );
}
